/**
 * Feature flags read from public env vars at build time.
 *
 *   NEXT_PUBLIC_ENABLE_ACCOUNTS
 *     "1" -> customer accounts (sign-in, register, /account/*, user nav
 *     widget, mobile account section) are visible.
 *     unset / anything else -> everything hides and the pages redirect home.
 *
 * Set this in dev's .env (so test.716cannabisllc.com keeps the WIP flow),
 * leave it unset in prod's .env so nothing ships to real customers until
 * we're ready.
 */

export function accountsEnabled(): boolean {
  return process.env.NEXT_PUBLIC_ENABLE_ACCOUNTS === "1";
}
